import script from "./End-Screen.vue?vue&type=script&setup=true&lang=js"
export * from "./End-Screen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__